import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavLinkClick = () => {
    setIsExpanded(false);
  };

  return (
    <Navbar 
      expand="lg" 
      fixed="top"
      expanded={isExpanded}
      onToggle={(expanded) => setIsExpanded(expanded)}
      className={`py-3 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
      style={{
        transition: 'all 0.3s ease',
        backgroundColor: isScrolled 
          ? 'rgba(255, 255, 255, 0.95)' 
          : isExpanded 
            ? 'rgba(255, 255, 255, 0.95)' 
            : 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)'
      }}
    >
      <Container>
        <Navbar.Brand 
          as={Link} 
          to="/" 
          className={`fw-bold ${isScrolled ? 'scrolled' : 'transparent'}`}
          onClick={handleNavLinkClick}
        >
          Stratis AI
        </Navbar.Brand>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className={isScrolled ? 'scrolled' : 'transparent'}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={`mx-2 ${location.pathname === '/' ? 'active' : ''} ${isScrolled ? 'scrolled' : 'transparent'}`}
              onClick={handleNavLinkClick}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/services" 
              className={`mx-2 ${location.pathname === '/services' ? 'active' : ''} ${isScrolled ? 'scrolled' : 'transparent'}`}
              onClick={handleNavLinkClick}
            >
              Services
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/about" 
              className={`mx-2 ${location.pathname === '/about' ? 'active' : ''} ${isScrolled ? 'scrolled' : 'transparent'}`}
              onClick={handleNavLinkClick}
            >
              About
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/contact" 
              className={`mx-2 ${location.pathname === '/contact' ? 'active' : ''} ${isScrolled ? 'scrolled' : 'transparent'}`}
              onClick={handleNavLinkClick}
            >
              Contact
            </Nav.Link>
            <Button 
              as={Link} 
              to="/contact" 
              variant={isScrolled ? "primary" : "light"}
              className="ms-3"
              onClick={handleNavLinkClick}
            >
              Get Started
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;